
const Formatter = {
    formatDay(dayTimestamp) {
        const date = new Date(dayTimestamp * 60000 * 60 * 24);
        return `${date.getDate()}.${date.getMonth()}.${date.getFullYear()}`;
    }
}

export default Formatter;